import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=08f60ebe&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=08f60ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f60ebe",
  null
  
)

export default component.exports